import { render } from "./StickyBox.vue?vue&type=template&id=885762dc&scoped=true"
import script from "./StickyBox.vue?vue&type=script&lang=js"
export * from "./StickyBox.vue?vue&type=script&lang=js"

import "./StickyBox.vue?vue&type=style&index=0&id=885762dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885762dc"]])

export default __exports__